module.exports = __webpack_public_path__ + "img/Group 427320382.2ea932e5.svg";